export class DtoMotivo {
    Codigo: string = '';
    Descripcion: string = '';
}